import { useCallback, useEffect, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Story from "@/components/site/Story";
import Products from "@/components/site/Products";
import Process from "@/components/site/Process";
import Policies from "@/components/site/Policies";
import OrderForm from "@/components/site/OrderForm";
import Reviews from "@/components/site/Reviews";
import Gallery from "@/components/site/Gallery";
import Patterns from "@/components/site/Patterns";
import Footer from "@/components/site/Footer";

export default function App() {
  const [orderItem, setOrderItem] = useState("");

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  const requestItem = useCallback((name) => {
    setOrderItem(name);
    document.getElementById("order")?.scrollIntoView({ behavior: "smooth" });
  }, []);

  return (
    <div className="min-h-screen bg-[#FDFBF7] font-sans text-[#2C2520] antialiased">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Story />
        <Products onRequest={requestItem} />
        <Reviews />
        <Gallery />
        <Process />
        <Policies />
        <OrderForm item={orderItem} onItemChange={setOrderItem} />
        <Patterns />
      </main>
      <Footer />
      <Toaster position="bottom-center" toastOptions={{ style: { background: "#2C2520", color: "#FDFBF7", border: "1px solid #4A423A" } }} />
    </div>
  );
}
